<script setup lang="ts">
import { onLaunch } from '@dcloudio/uni-app';
import { isLoggedIn } from '@/utils/auth';

onLaunch(() => {
  // 已登录则跳转个人中心，未登录默认控制台
  if (isLoggedIn()) {
    uni.switchTab({ url: '/pages/profile/index' });
  }
});
</script>
<style></style>
